import { StyleSheet } from "react-native-unistyles";

import isIPad from "$src/core/utils/device/is-ipad";

type VerticalOptions = {
  tabBarHeight?: number;
};

const isTabBarAtTop = !!isIPad;

const stylesheet = StyleSheet.create(({ spacing }, { insets }) => ({
  logo: ({ tabBarHeight = 0 }: VerticalOptions = {}) => ({
    position: "absolute",
    top: spacing(1) + insets.top + (isTabBarAtTop ? tabBarHeight : 0),
    height: spacing(22),
    aspectRatio: 4 / 3,
    zIndex: 1,
  }),
  tvConnectButtonContainer: ({ tabBarHeight = 0 }: VerticalOptions = {}) => ({
    position: "absolute",
    top: spacing(5) + insets.top + (isTabBarAtTop ? tabBarHeight : 0),
    right: spacing(6) + insets.right,
    zIndex: 1,
  }),
}));

export default stylesheet;
